import RequestV2 from './request-v2.http';

export default class ContactHttpService {
    private static uri = 'contact';

    public static readMany(params: {
        skip?: number;
        take?: number;
        term?: string;
    }) {
        return RequestV2.get(`${this.uri}`, params);
    }
}
